import React from "react";

import styles from "./integration.css";
import { QuestionFooter, QuestionHeader } from "./Question";


function Integration ({title, completeFormModel, config, onChange, onDelete }) {
	const onChangeConfig = newProps => onChange({ ...config, ...newProps });

	return (
		<>
			<QuestionHeader config={config} onChangeConfig={onChangeConfig} />
			<div className={`ui form ${styles.container}`}>
				<div className={styles.iconButton}>
					{title}
				</div>
			</div>
			<QuestionFooter
				completeFormModel={completeFormModel}
				config={config}
				onChangeConfig={onChangeConfig}
				onDelete={onDelete}
			>
			</QuestionFooter>
		</>
	);
}


export default Integration;
